import type { MediaItem } from "@/types/media";

export const mediaList: MediaItem[] = [
  {
    id: "1",
    title: "星际回声",
    originalTitle: "Echoes of the Void",
    category: "movie",
    genres: ["科幻", "冒险", "剧情"],
    region: "美国",
    year: 2026,
    rating: 8.9,
    heat: 98,
    recommendWeight: 99,
    director: "艾伦·沃德",
    cast: ["凯拉·门罗", "伊桑·格兰特", "诺亚·贝内特"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%2C%20lone%20astronaut%20facing%20a%20giant%20glowing%20ring%20in%20deep%20space%2C%20deep%20orange%20and%20amber%20nebula%20light%2C%20dark%20moody%20background%2C%20dramatic%20rim%20lighting%2C%20no%20text%2C%20high%20detail%20editorial%20composition&width=600&height=900&seq=hh-m01&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20scene%2C%20astronaut%20silhouette%20before%20a%20vast%20glowing%20space%20ring%2C%20deep%20orange%20amber%20nebula%2C%20dark%20dramatic%20space%20background%2C%20no%20text%2C%20epic%20wide%20composition&width=1200&height=675&seq=hh-m01w&orientation=landscape",
    duration: "142 分钟",
    releaseDate: "2026-03-14",
    tagline: "在宇宙的尽头，听见了自己的回声。",
    synopsis:
      "当人类最后一艘深空考察舰“回声号”抵达已知宇宙边缘时，导航员埃拉发现所有的信号都指向同一个方向——地球。为了查明真相，她必须独自穿越一片会扭曲记忆的星云。影片以冷峻的硬核科幻为外壳，内里却是一个关于孤独、归乡与自我和解的故事。导演艾伦·沃德用大量留白的长镜头和低沉的环境音，营造出令人窒息的寂静感，把宇宙的浩瀚与个体的渺小并置在同一帧画面里。这是一部需要在大银幕上、用最大音量去感受的电影。",
  },
  {
    id: "2",
    title: "长夜将尽",
    originalTitle: "Before the Long Night",
    category: "movie",
    genres: ["悬疑", "犯罪", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.4,
    heat: 95,
    recommendWeight: 96,
    director: "沈立",
    cast: ["张赫铭", "林晚", "周听澜", "郭淮"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20movie%20poster%2C%20rainy%20night%20city%20alley%20with%20a%20lone%20figure%20under%20a%20streetlamp%2C%20deep%20orange%20light%20against%20dark%20blue%20shadows%2C%20moody%20atmosphere%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-m02&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20noir%20city%20at%20night%20in%20heavy%20rain%2C%20empty%20street%20with%20warm%20orange%20street%20lamps%2C%20dark%20moody%20crime%20drama%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-m02w&orientation=landscape",
    duration: "128 分钟",
    releaseDate: "2025-11-08",
    tagline: "天亮之前，真相必须先醒过来。",
    synopsis:
      "一个暴雨连绵的南方小城，一桩尘封二十年的旧案随着一具遗体的发现重新翻开。退休刑警陈默本打算在钓鱼和失眠中度过余生，却被当年的一个细节拽回了案件现场。随着调查深入，他发现所有线索都指向了如今已身居高位的旧日同僚。影片没有炫技的追车与枪战，而是把张力藏在每一次沉默的对视和每一句欲言又止的对话里。沈立用克制的镜头语言，讲述了一个关于时间、悔恨与选择的故事，也让观众在最后一幕重新理解了“长夜”的真正含义。",
  },
  {
    id: "3",
    title: "雾都谜案",
    originalTitle: "The Fogtown Files",
    category: "tv",
    genres: ["悬疑", "犯罪", "剧情"],
    region: "英国",
    year: 2024,
    rating: 8.7,
    heat: 92,
    recommendWeight: 94,
    director: "奥利弗·黑尔",
    cast: ["艾米莉亚·斯旺", "詹姆斯·柯尔", "露西·阿什顿"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20british%20mystery%20series%20poster%2C%20victorian%20style%20detective%20in%20thick%20fog%20lit%20by%20a%20warm%20lantern%2C%20deep%20orange%20glow%20through%20grey%20mist%2C%20moody%20atmospheric%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-t01&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20foggy%20old%20english%20town%20at%20dusk%2C%20gas%20lamps%20casting%20warm%20orange%20light%20through%20mist%2C%20dark%20mystery%20drama%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-t01w&orientation=landscape",
    duration: "全 8 集",
    releaseDate: "2024-09-20",
    tagline: "雾散之时，人心自现。",
    synopsis:
      "故事发生在十九世纪末一座终年被浓雾笼罩的港口城市。年轻的女探员艾米莉亚·斯旺被派往当地调查一连串离奇的失踪案，却发现这座城市的每一个居民都像雾一样难以看清。在八集的篇幅里，剧集用缓慢而扎实的节奏铺陈线索，每一条支线人物都拥有完整的动机与秘密。它不满足于给出一个凶手，而是试图追问：当整座城市都选择沉默，正义该由谁来执行。冷色调的画面与偶尔透出的橙色灯光形成强烈对比，把维多利亚时代的压抑感刻画得淋漓尽致。",
  },
  {
    id: "4",
    title: "山海拾遗",
    originalTitle: "Chronicles of Mountains and Seas",
    category: "tv",
    genres: ["奇幻", "历史", "冒险"],
    region: "中国大陆",
    year: 2026,
    rating: 8.6,
    heat: 97,
    recommendWeight: 98,
    director: "顾北渊",
    cast: ["苏未晞", "陆时衍", "殷长风"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20chinese%20fantasy%20series%20poster%2C%20ancient%20scholar%20holding%20a%20glowing%20scroll%20before%20mystical%20mountains%2C%20deep%20orange%20and%20amber%20light%2C%20dark%20ink%20painting%20background%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-t02&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=epic%20chinese%20fantasy%20landscape%2C%20floating%20mountains%20and%20glowing%20ancient%20ruins%20at%20sunset%2C%20deep%20orange%20amber%20sky%2C%20ink%20painting%20style%2C%20no%20text%2C%20wide%20cinematic%20composition&width=1200&height=675&seq=hh-t02w&orientation=landscape",
    duration: "全 12 集",
    releaseDate: "2026-01-16",
    tagline: "被遗忘的奇谈，终有人替山海记下。",
    synopsis:
      "青年学者陆时衍意外得到一册残缺的古籍，书中的异兽与山川竟能与现实一一对应。为了补全这本《山海拾遗》，他踏上了一场跨越南北的旅程。剧集将东方美学与奇幻冒险巧妙结合，既有瑰丽想象，也有一路走来的人间烟火。每一集都像一则独立的志怪短篇，又通过主角的成长串联成完整的叙线。制作团队在服化道与取景上极为考究，把水墨山水的意境搬进了荧幕，让观众在追剧的同时也能感受到一次真正意义上的文化远行。",
  },
  {
    id: "5",
    title: "潮汐之城",
    originalTitle: "Tide City",
    category: "movie",
    genres: ["剧情", "爱情"],
    region: "韩国",
    year: 2025,
    rating: 8.2,
    heat: 88,
    recommendWeight: 90,
    director: "金志勋",
    cast: ["朴叙妍", "李在寅"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20romance%20drama%20movie%20poster%2C%20couple%20standing%20apart%20on%20a%20windy%20seaside%20pier%20at%20sunset%2C%20deep%20orange%20sky%2C%20moody%20melancholic%20tone%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-m03&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20seaside%20city%20at%20golden%20sunset%2C%20long%20pier%20reflecting%20deep%20orange%20light%20on%20calm%20water%2C%20melancholic%20romance%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-m03w&orientation=landscape",
    duration: "118 分钟",
    releaseDate: "2025-07-11",
    tagline: "潮水每天都会回来，人却不一定。",
    synopsis:
      "在一个靠海的小城，气象观测员妍熙每天记录着潮汐的涨落，也记录着自己失去联系多年的初恋。当那位已经成为海洋生物学家的旧人突然回到这座城，两人被迫面对当年不告而别的真相。影片没有激烈的争吵，也没有煽情的重逢，而是用一次次的沉默、一顿顿没吃完的饭，把成年人之间那种欲言又止的感情描摹得细腻又真实。海边的光线变化成为情绪的隐喻，潮起潮落之间，观众也跟着主人公一起，学会了与过去和解。",
  },
  {
    id: "6",
    title: "第七封信",
    originalTitle: "The Seventh Letter",
    category: "movie",
    genres: ["悬疑", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.1,
    heat: 84,
    recommendWeight: 87,
    director: "何砚舟",
    cast: ["温如许", "江砚白"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20mystery%20drama%20movie%20poster%2C%20stack%20of%20old%20yellowed%20letters%20on%20a%20wooden%20desk%20lit%20by%20a%20warm%20lamp%2C%20deep%20orange%20glow%2C%20dark%20shadowy%20background%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-m04&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20old%20library%20desk%20at%20night%2C%20scattered%20vintage%20letters%20and%20a%20single%20warm%20lamp%2C%20deep%20orange%20light%20in%20dark%20room%2C%20mystery%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-m04w&orientation=landscape",
    duration: "106 分钟",
    releaseDate: "2024-10-25",
    tagline: "有些信，寄出的人早已不在。",
    synopsis:
      "整理祖母遗物的年轻编辑江砚白，在阁楼里发现了六封未署名、未寄出的旧信。信的落款都停在同一年，却在第七封处戛然而止。为了解开这个谜，她开始按信中的线索追踪一位早已过世的老人，也渐渐拼凑出一段被家族刻意遗忘的往事。影片结构精巧，把“解谜”与“寻亲”两条线交织在一起，每一次翻信都像是推开一扇新门。它让观众意识到，有些真相并不是为了让人释怀，而是为了让人记住。最后的反转克制而有力，值得反复回味。",
  },
  {
    id: "7",
    title: "银河驿站",
    originalTitle: "Galaxy Waystation",
    category: "tv",
    genres: ["科幻", "剧情", "冒险"],
    region: "美国",
    year: 2025,
    rating: 8.5,
    heat: 90,
    recommendWeight: 93,
    director: "玛雅·柯林斯",
    cast: ["德里克·肖", "艾拉·诺瓦克", "本·卡特"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20space%20station%20sci-fi%20series%20poster%2C%20glowing%20orbital%20station%20window%20with%20a%20lone%20traveler%2C%20deep%20orange%20amber%20interior%20light%2C%20dark%20space%20outside%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-t03&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20orbital%20space%20station%20above%20a%20planet%20at%20sunrise%2C%20warm%20orange%20light%20streaming%20through%20windows%2C%20sci-fi%20drama%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-t03w&orientation=landscape",
    duration: "全 10 集",
    releaseDate: "2025-05-02",
    tagline: "宇宙最后一站，收留所有迷路的人。",
    synopsis:
      "在星际航道的尽头，悬浮着一座被称为“银河驿站”的补给站。站长德里克和几位背景各异的船员，每天接待形形色色的过客：逃亡的赏金猎人、寻找故乡的移民船、以及一台坚信自己有灵魂的机器人。剧集用单元剧的形式展开，每集聚焦一位访客的故事，又在季末将这些线索汇聚成一场关乎整座驿站存亡的危机。它表面是科幻，内核却是关于善意与归属的温柔寓言。温暖的光线设计让冰冷的太空多了几分人情味，是近年少见的治愈系科幻佳作。",
  },
  {
    id: "8",
    title: "无声告白",
    originalTitle: "A Quiet Confession",
    category: "movie",
    genres: ["剧情", "家庭"],
    region: "日本",
    year: 2024,
    rating: 8.3,
    heat: 80,
    recommendWeight: 85,
    director: "小野寺凉",
    cast: ["佐藤千夏", "高桥隼人"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20japanese%20family%20drama%20movie%20poster%2C%20elderly%20woman%20and%20young%20girl%20sitting%20in%20a%20warm%20sunlit%20kitchen%2C%20deep%20orange%20afternoon%20light%2C%20tender%20melancholic%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-m05&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20japanese%20countryside%20house%20at%20golden%20hour%2C%20warm%20orange%20sunlight%20through%20a%20kitchen%20window%2C%20tender%20family%20drama%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-m05w&orientation=landscape",
    duration: "124 分钟",
    releaseDate: "2024-06-08",
    tagline: "有些话，一辈子都没说出口。",
    synopsis:
      "在乡下经营着一间小杂货店的独居老人佐和子，突然迎来了从未谋面的孙女千夏。为了照顾病中的儿子，千夏不得不暂时住进这个沉默寡言的老屋。祖孙二人从最初的生疏与误解，到在一日三餐和柴米油盐中慢慢靠近。影片几乎没有任何配乐，全靠自然光与生活细节推动情感——一碗热汤、一次并肩的散步、一句始终没说出口的“对不起”。导演小野寺凉用极简的叙事，拍出了最厚重的亲情，让人在平静中不知不觉红了眼眶。",
  },
  {
    id: "9",
    title: "铁血黎明",
    originalTitle: "Dawn of Valor",
    category: "movie",
    genres: ["动作", "战争", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.0,
    heat: 91,
    recommendWeight: 89,
    director: "岳撼山",
    cast: ["秦烈", "郝振国", "孟星河"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20war%20action%20movie%20poster%2C%20soldier%20silhouette%20standing%20against%20a%20burning%20orange%20dawn%20sky%2C%20smoke%20and%20embers%2C%20dark%20dramatic%20tone%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-m06&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20war%20landscape%20at%20dawn%2C%20silhouettes%20of%20soldiers%20marching%20through%20smoke%20under%20deep%20orange%20sky%2C%20epic%20dramatic%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-m06w&orientation=landscape",
    duration: "136 分钟",
    releaseDate: "2025-09-03",
    tagline: "黎明之前，总要有人先站出来。",
    synopsis:
      "故事聚焦一支在历史洪流中几乎被遗忘的小分队。他们奉命守住一座不起眼的山口，为主力部队争取三天时间。三天里，粮食耗尽、通讯中断、战友一个个倒下，支撑他们的只有彼此之间的信任和一句简单的约定。影片在宏大的战争场面之外，花了大量笔墨刻画普通士兵的恐惧、犹豫与成长，让英雄不再只是符号。爆破与摄影调度极具质感，而真正让人记住的，是那些在炮火中依然会想念家乡饭菜的年轻人。",
  },
  {
    id: "10",
    title: "午后咖啡馆",
    originalTitle: "Afternoon Cafe",
    category: "tv",
    genres: ["喜剧", "爱情", "都市"],
    region: "韩国",
    year: 2026,
    rating: 7.9,
    heat: 82,
    recommendWeight: 83,
    director: "车敏智",
    cast: ["韩素妍", "吴允浩"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20romantic%20comedy%20series%20poster%2C%20cozy%20cafe%20interior%20with%20warm%20orange%20afternoon%20light%20and%20a%20latte%20on%20the%20table%2C%20cheerful%20warm%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-t04&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cozy%20sunlit%20cafe%20interior%2C%20warm%20orange%20afternoon%20sunlight%20through%20large%20windows%2C%20inviting%20cheerful%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-t04w&orientation=landscape",
    duration: "全 16 集",
    releaseDate: "2026-02-12",
    tagline: "一杯咖啡的时间，够喜欢一个人吗？",
    synopsis:
      "在一家藏在巷子深处、生意冷清的小咖啡馆里，老板允浩坚持只做手冲，而新来的兼职生素妍却是效率至上的连锁快餐派。两人理念完全相反，却因为一次意外的合租成为朝夕相处的邻居。剧集用轻松幽默的方式讲述都市年轻人的日常：相亲失败的尴尬、创业的狼狈、还有那种来不及说出口的心动。节奏明快，笑点自然，配角群像也个个鲜活。它不制造狗血冲突，只是温柔地告诉观众，爱情有时就像一杯慢咖啡，急不得。",
  },
  {
    id: "11",
    title: "深空档案",
    originalTitle: "Deep Space Dossier",
    category: "tv",
    genres: ["科幻", "悬疑", "惊悚"],
    region: "美国",
    year: 2024,
    rating: 8.4,
    heat: 86,
    recommendWeight: 88,
    director: "内森·布莱克",
    cast: ["安娜·维尔的", "科林·格雷"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20thriller%20series%20poster%2C%20dark%20spacecraft%20corridor%20with%20a%20single%20glowing%20orange%20warning%20light%2C%20tense%20mysterious%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-t05&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20dark%20spaceship%20interior%20with%20warm%20orange%20emergency%20lighting%2C%20tense%20sci-fi%20thriller%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-t05w&orientation=landscape",
    duration: "全 9 集",
    releaseDate: "2024-08-15",
    tagline: "档案不会说谎，但记录档案的人会。",
    synopsis:
      "一艘失联多年的实验飞船突然自动返航，船上七名船员全部消失，只留下一份加密的航行日志。调查组逐一破解日志，却发现每次记录的内容都与前一次相互矛盾。剧集以伪纪录片式的冷静笔触推进，把恐怖感建立在“无法确定真相”上，而非廉价的血腥画面。随着线索层层剥开，观众会不断怀疑眼前的叙述者是否可信。悬念铺陈扎实，氛围营造一流，是一部把硬科幻和心理学惊悚融合得恰到好处的作品。",
  },
  {
    id: "12",
    title: "少女与海",
    originalTitle: "The Girl and the Sea",
    category: "movie",
    genres: ["动画", "奇幻", "剧情"],
    region: "日本",
    year: 2025,
    rating: 8.8,
    heat: 87,
    recommendWeight: 92,
    director: "新堂海音",
    cast: ["声优：花泽凛", "声优：宫下昌"],
    poster: "https://readdy.ai/api/search-image?query=anime%20movie%20poster%2C%20young%20girl%20standing%20on%20a%20cliff%20overlooking%20a%20glowing%20orange%20sea%20at%20sunset%2C%20magical%20painterly%20style%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-m07&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=anime%20style%20vast%20glowing%20orange%20sea%20at%20sunset%20with%20distant%20cliffs%2C%20dreamy%20painterly%20fantasy%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-m07w&orientation=landscape",
    duration: "96 分钟",
    releaseDate: "2025-08-22",
    tagline: "海的尽头，藏着她不敢想起的名字。",
    synopsis:
      "海边小镇的少女阿海，在祖母去世后常常梦见一片会发光的海。某天夜里，她真的在礁石边遇见了一只会说话的白鲸，并被告知只要找回三个遗失的记忆碎片，就能再见祖母一面。影片以细腻的手绘风格展开一段关于告别与成长的奇幻旅程，画面之美几乎每一帧都能截下来当壁纸。配乐由清冷的钢琴与海浪声交织而成，情绪层层递进。它讲述的不只是童话，更是一个孩子如何学会接受失去、带着爱继续往前走的温柔故事。",
  },
  {
    id: "13",
    title: "边境来信",
    originalTitle: "Letters from the Border",
    category: "movie",
    genres: ["剧情", "犯罪"],
    region: "法国",
    year: 2024,
    rating: 8.0,
    heat: 74,
    recommendWeight: 81,
    director: "露西·德莱",
    cast: ["卡米耶·罗", "安托万·佩"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20european%20crime%20drama%20movie%20poster%2C%20lonely%20postman%20on%20an%20empty%20road%20at%20dusk%2C%20deep%20orange%20sky%2C%20windswept%20melancholic%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-m08&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20empty%20country%20road%20through%20a%20windswept%20landscape%20at%20dusk%2C%20deep%20orange%20sky%2C%20lonely%20drama%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-m08w&orientation=landscape",
    duration: "112 分钟",
    releaseDate: "2024-11-30",
    tagline: "每一封信，都是一次没说出口的告别。",
    synopsis:
      "在两国交界的偏远小镇，邮差安托万每天骑着旧摩托穿梭在荒凉的山路上，为居民递送那些可能永远无人回应的信件。直到某天，他注意到一封反复被退回、收件人早已去世的信，并决定亲手将它送到该去的地方。这趟看似简单的旅程，却逐步牵出一起被掩盖多年的边境旧案。影片节奏舒缓，却始终暗流涌动，用信件的层层展开推动真相浮现。它温柔地提醒我们：善意有时微小，却足以改变一个人的一生。",
  },
  {
    id: "14",
    title: "都市浮生",
    originalTitle: "Metropolitan Days",
    category: "tv",
    genres: ["剧情", "都市"],
    region: "中国大陆",
    year: 2025,
    rating: 8.2,
    heat: 83,
    recommendWeight: 86,
    director: "程见山",
    cast: ["许知南", "黎川", "方念念"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20series%20poster%2C%20young%20professionals%20on%20a%20city%20rooftop%20at%20night%20overlooking%20glowing%20warm%20orange%20lights%2C%20reflective%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-t06&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20city%20skyline%20at%20night%20with%20warm%20orange%20window%20lights%2C%20reflective%20urban%20drama%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-t06w&orientation=landscape",
    duration: "全 24 集",
    releaseDate: "2025-03-28",
    tagline: "在这座城里，每个人都在用力活着。",
    synopsis:
      "剧集以三个合租在一套老公寓里的年轻人为主线，讲述他们在大城市里打拼的五年。程序员许知南想要安稳，服装设计助理方念念渴望被看见，而送外卖的黎川则在为老家生病的母亲攒钱。他们的生活由面试失败、房租上涨、深夜加班和偶尔的相互取暖组成，没有逆袭神话，只有一步一个脚印的坚持。剧本扎根现实，台词真实到令人心头一紧，又不失温暖。它让观众在角色身上看到自己，也看到那种在疲惫中依然选择继续往前走的倔强。",
  },
  {
    id: "15",
    title: "时间褶皱",
    originalTitle: "Folds of Time",
    category: "movie",
    genres: ["科幻", "剧情", "悬疑"],
    region: "英国",
    year: 2026,
    rating: 8.6,
    heat: 89,
    recommendWeight: 95,
    director: "亨利·阿什克罗夫特",
    cast: ["奥利维亚·瑞德", "塞缪尔·凯恩"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20drama%20movie%20poster%2C%20person%20standing%20before%20a%20distorted%20spiraling%20corridor%20of%20orange%20light%2C%20surreal%20dreamlike%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-m09&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=surreal%20cinematic%20corridor%20warping%20into%20a%20spiral%20of%20warm%20orange%20light%2C%20dreamlike%20sci-fi%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-m09w&orientation=landscape",
    duration: "130 分钟",
    releaseDate: "2026-04-17",
    tagline: "如果时间可以折叠，你最想再见谁一面。",
    synopsis:
      "物理学家奥利维亚在一次实验中意外发现，时间并非直线，而是可以被“折叠”的褶皱。她借此一次次回到那个改变命运的雨夜，试图挽回一场失去，却发现每一次修改都会引发新的连锁反应。影片把复杂的时空理论与细腻的情感创伤结合在一起，既有烧脑的推理，也有令人心碎的执念。导演用循环往复的镜头语言，让观众和主角一起在希望与绝望之间反复挣扎。它最终提出的问题很简单：真正的告别，是不是放过自己。",
  },
  {
    id: "16",
    title: "燃烧的证词",
    originalTitle: "Burning Testimony",
    category: "movie",
    genres: ["犯罪", "悬疑", "动作"],
    region: "中国香港",
    year: 2024,
    rating: 7.8,
    heat: 85,
    recommendWeight: 84,
    director: "麦兆铭",
    cast: ["雷洛", "陈嘉树", "何静仪"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20hong%20kong%20crime%20thriller%20poster%2C%20detective%20silhouette%20before%20a%20burning%20car%20in%20an%20alley%2C%20deep%20orange%20flames%20in%20the%20dark%2C%20tense%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-m10&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20hong%20kong%20night%20street%20with%20deep%20orange%20flames%20and%20neon%20reflections%2C%20tense%20crime%20thriller%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-m10w&orientation=landscape",
    duration: "114 分钟",
    releaseDate: "2024-12-12",
    tagline: "证据会燃烧，但真相不会。",
    synopsis:
      "一名卧底警员在即将收网的前夜身份暴露，留给搭档的只有一段烧毁一半的录音。为了替同事讨回公道，重案组探员雷洛不得不在黑白两道之间小心周旋。影片延续了港式警匪片凌厉的剪辑与紧凑的节奏，街头追逐与近身搏斗拳拳到肉。但真正动人的是角色之间的情义与选择：当规则失灵，一个人还能守住多少底线。最后的对峙没有华丽台词，只有沉默中的子弹与眼神，把整部电影的情绪推到顶点后再狠狠收住。",
  },
  {
    id: "17",
    title: "春夜喜雨",
    originalTitle: "Spring Rain",
    category: "tv",
    genres: ["爱情", "剧情", "治愈"],
    region: "中国大陆",
    year: 2026,
    rating: 8.1,
    heat: 81,
    recommendWeight: 85,
    director: "白露清",
    cast: ["沈知夏", "顾南舟"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20chinese%20romance%20series%20poster%2C%20young%20woman%20holding%20an%20umbrella%20in%20spring%20rain%20under%20warm%20orange%20streetlamp%2C%20gentle%20romantic%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-t07&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20rainy%20spring%20street%20at%20night%20with%20warm%20orange%20lamps%20and%20blossoms%2C%20gentle%20romantic%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-t07w&orientation=landscape",
    duration: "全 18 集",
    releaseDate: "2026-03-06",
    tagline: "真正的喜欢，是陪你等雨停。",
    synopsis:
      "植物学研究生沈知夏在一场春雨里弄丢了重要的实验笔记，也遇见了在旧书店打工的顾南舟。两人从一本旧诗集开始，慢慢走进彼此的生活。剧集没有狗血的三角关系，也没有夸张的命运巧合，而是把重心放在日常相处中的小细节：一起躲雨、共养一盆植物、深夜的语音留言。画面温柔明亮，配乐舒缓，像一杯热茶慢慢化开。它讲述的是一段细水长流的感情如何被小心翼翼地经营，也让人重新相信，平淡里的坚持最动人。",
  },
  {
    id: "18",
    title: "荒原猎手",
    originalTitle: "Wasteland Hunter",
    category: "movie",
    genres: ["动作", "冒险", "科幻"],
    region: "美国",
    year: 2025,
    rating: 7.7,
    heat: 88,
    recommendWeight: 82,
    director: "杰克·穆尔",
    cast: ["科尔·哈丁", "娜塔莉·文"],
    poster: "https://readdy.ai/api/search-image?query=post%20apocalyptic%20action%20movie%20poster%2C%20lone%20hunter%20with%20a%20rifle%20walking%20across%20a%20dusty%20wasteland%20at%20orange%20sunset%2C%20dramatic%20cinematic%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-m11&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=post%20apocalyptic%20vast%20dusty%20wasteland%20at%20deep%20orange%20sunset%2C%20lone%20traveler%20silhouette%2C%20epic%20cinematic%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-m11w&orientation=landscape",
    duration: "120 分钟",
    releaseDate: "2025-06-27",
    tagline: "在这片荒原上，活下来就是本事。",
    synopsis:
      "资源枯竭后的世界已沦为一片黄沙。独来独往的猎手哈丁靠捕捉废墟里的机械残骸为生，从不相信任何人。直到他救下一名掌握着净水技术秘密的少女，不得不带着她穿越整片荒原，躲避各方势力的追捕。影片把公路片的自由感与末世题材的荒凉气质结合得恰到好处，动作场面干净利落。但它的核心仍是关于信任：一个习惯独自活着的硬汉，如何慢慢学会为别人挡下子弹。结尾留下的那点微光，足以支撑整个故事。",
  },
  {
    id: "19",
    title: "灯下故人",
    originalTitle: "Old Friends Under the Lamp",
    category: "tv",
    genres: ["历史", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.5,
    heat: 78,
    recommendWeight: 87,
    director: "徐砚秋",
    cast: ["程亦安", "齐长风", "苏念"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20chinese%20historical%20drama%20series%20poster%2C%20scholar%20sitting%20under%20a%20warm%20oil%20lamp%20writing%20by%20hand%2C%20deep%20orange%20light%20in%20dark%20study%2C%20elegant%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-t08&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20chinese%20historical%20study%20lit%20by%20warm%20orange%20lamplight%2C%20ink%20brushes%20and%20scrolls%2C%20elegant%20scholarly%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-t08w&orientation=landscape",
    duration: "全 14 集",
    releaseDate: "2024-07-19",
    tagline: "一盏灯，一段往事，一生故人。",
    synopsis:
      "剧集以一盏从旧宅流传下来的铜灯为引，讲述同为书院同窗的三位挚友，在时代变迁中走向截然不同人生道路的故事。有人入仕，有人从商，有人守着一方书斋教书育人。多年后重聚，物是人非，唯有当年灯下的约定犹在耳畔。剧本考据严谨，文言对白与生活细节并重，把一个大时代下知识分子的抉择与坚守描摹得厚重而不沉闷。它不歌颂成功，也不谴责失败，只是安静地呈现每一个人如何在洪流中，努力活成自己相信的样子。",
  },
  {
    id: "20",
    title: "量子恋人",
    originalTitle: "Quantum Lovers",
    category: "movie",
    genres: ["科幻", "爱情"],
    region: "韩国",
    year: 2026,
    rating: 8.0,
    heat: 86,
    recommendWeight: 88,
    director: "崔仁호",
    cast: ["郑夏恩", "姜道允"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20romance%20movie%20poster%2C%20couple%20reaching%20for%20each%20other%20across%20glowing%20particle%20fields%20of%20warm%20orange%20light%2C%20dreamy%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-m12&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20glowing%20orange%20particle%20field%2C%20two%20figures%20reaching%20toward%20each%20other%2C%20dreamy%20sci-fi%20romance%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-m12w&orientation=landscape",
    duration: "122 分钟",
    releaseDate: "2026-02-20",
    tagline: "在无数个平行世界里，我都选择遇见你。",
    synopsis:
      "物理系研究生夏恩坚信平行世界的存在，却始终无法证明。直到一次实验事故，她开始在不同版本的现实中来回跳跃，而每一个世界里，都有一个叫道允的人以不同身份与她相遇。影片把浪漫建立在一个迷人的假设之上：如果命运有无数种可能，我们的爱是否依然必然。视觉上大量运用粒子与光晕，营造出梦幻而略带忧伤的氛围。它既是一封写给科学的情书，也是一段关于“无论重来多少次都会选你”的深情告白，结尾的处理尤其令人回味。",
  },
  {
    id: "21",
    title: "沉默的证词",
    originalTitle: "Silent Testimony",
    category: "tv",
    genres: ["悬疑", "剧情"],
    region: "日本",
    year: 2025,
    rating: 8.3,
    heat: 79,
    recommendWeight: 86,
    director: "森田悠",
    cast: ["木村凉子", "中岛海斗"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20japanese%20mystery%20series%20poster%2C%20woman%20facing%20a%20rain%20streaked%20window%20at%20night%20lit%20by%20warm%20orange%20light%2C%20tense%20quiet%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-t09&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20rainy%20night%20window%20with%20warm%20orange%20interior%20light%2C%20quiet%20tense%20mystery%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-t09w&orientation=landscape",
    duration: "全 11 集",
    releaseDate: "2025-10-10",
    tagline: "最响亮的证词，往往是沉默。",
    synopsis:
      "一位专门为聋哑人做手语翻译的法院助理，在一次杀人案的审理中，发现唯一的目击者——一个失语的少年——其手语陈述与现场证据完全矛盾。为了查明究竟是谁在说谎，她开始独自走访案件的每一个角落。剧集以极致的细节和冷静的推理见长，把听觉的缺失转化为一种独特的悬疑视角。它探讨了沟通的边界、偏见的伤害，以及在无声世界里正义如何被听见。人物刻画饱满，情绪克制却极具穿透力，是一部值得静下心来细品的作品。",
  },
  {
    id: "22",
    title: "荣耀之路",
    originalTitle: "Road to Glory",
    category: "movie",
    genres: ["运动", "励志", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.2,
    heat: 84,
    recommendWeight: 87,
    director: "韩正阳",
    cast: ["罗一鸣", "简宁", "马骁"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20sports%20drama%20movie%20poster%2C%20young%20runner%20sprinting%20on%20a%20track%20at%20orange%20sunset%2C%20sweat%20and%20determination%2C%20dramatic%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-m13&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20running%20track%20at%20deep%20orange%20sunset%2C%20silhouette%20of%20a%20sprinter%2C%20inspiring%20sports%20drama%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-m13w&orientation=landscape",
    duration: "126 分钟",
    releaseDate: "2025-04-25",
    tagline: "终点线从不问出身，只问你能跑多远。",
    synopsis:
      "来自小县城的少年罗一鸣从小就梦想成为一名短跑运动员，可天赋平平的他在体校里始终是最不起眼的那个。为了不让家里失望，也为了不放弃自己，他把每一次训练都当成最后的机会。影片没有把他塑造成天才，而是老老实实地讲述一个普通人靠坚持一点一点追上别人的过程。教练的严厉、队友的竞争、受伤的挫折，都被拍得真实而有力量。比赛高潮的剪辑尤其出色，让人几乎能感受到风从耳边掠过，是一部看完想立刻去跑步的励志电影。",
  },
  {
    id: "23",
    title: "午夜列车",
    originalTitle: "The Midnight Train",
    category: "movie",
    genres: ["惊悚", "悬疑"],
    region: "英国",
    year: 2024,
    rating: 7.6,
    heat: 76,
    recommendWeight: 80,
    director: "乔治亚·芬奇",
    cast: ["哈里森·里德", "艾玛·柯尔"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20thriller%20movie%20poster%2C%20empty%20night%20train%20carriage%20with%20warm%20orange%20lights%20and%20dark%20windows%2C%20eerie%20tense%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-m14&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20empty%20night%20train%20interior%20with%20warm%20orange%20lighting%20and%20dark%20windows%2C%20eerie%20thriller%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-m14w&orientation=landscape",
    duration: "98 分钟",
    releaseDate: "2024-10-04",
    tagline: "这趟车，没有下一站。",
    synopsis:
      "深夜的末班列车上，五名素不相识的乘客发现列车不会停靠任何车站，手机也失去了信号。随着车厢里的灯光一次次熄灭，他们开始意识到，彼此之间似乎存在着某种不为人知的联系。影片把空间压缩在一节小小的车厢里，靠对话、光影和音效制造持续的压迫感。它既是封闭空间惊悚，也是一则关于愧疚与救赎的寓言。结尾的真相揭晓干净利落，让人重新回看此前每一个细节，都能品出不一样的意味。",
  },
  {
    id: "24",
    title: "云上之城",
    originalTitle: "City Above the Clouds",
    category: "tv",
    genres: ["奇幻", "冒险", "剧情"],
    region: "中国大陆",
    year: 2026,
    rating: 8.4,
    heat: 93,
    recommendWeight: 94,
    director: "洛清野",
    cast: ["云知遥", "穆白", "柳含烟"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20adventure%20series%20poster%2C%20young%20traveler%20standing%20before%20a%20floating%20city%20above%20clouds%20at%20orange%20sunset%2C%20epic%20dreamy%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-t10&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=epic%20fantasy%20floating%20city%20above%20a%20sea%20of%20clouds%20at%20deep%20orange%20sunset%2C%20dreamy%20adventure%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-t10w&orientation=landscape",
    duration: "全 13 集",
    releaseDate: "2026-05-08",
    tagline: "云海之上，还有另一个世界。",
    synopsis:
      "传说在云层深处漂浮着一座失落的天空之城，只有心怀执念的人才能找到入口。少女云知遥带着母亲的遗愿踏上寻城之路，一路结识了沉默的剑客穆白与通晓古籍的柳含烟。剧集构建了一个完整而瑰丽的幻想世界，从飞行船到云兽，从浮空岛屿到古老遗迹，视觉想象大胆又统一。故事在冒险之外，也细腻地探讨了亲情、承诺与放下。多条情感线的收束自然流畅，让这个架空的世界有了真实可触的温度，是近年国产奇幻的一次亮眼尝试。",
  },
  {
    id: "25",
    title: "双面人生",
    originalTitle: "Two-Faced Life",
    category: "tv",
    genres: ["剧情", "悬疑", "都市"],
    region: "中国香港",
    year: 2025,
    rating: 8.1,
    heat: 80,
    recommendWeight: 84,
    director: "方镇南",
    cast: ["卓文轩", "叶芊芊"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20hong%20kong%20drama%20series%20poster%2C%20man%20reflected%20in%20two%20mirrors%20with%20warm%20orange%20and%20dark%20tones%2C%20psychological%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-t11&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20hong%20kong%20night%20street%20with%20warm%20orange%20neon%20reflections%20and%20dark%20tones%2C%20psychological%20drama%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-t11w&orientation=landscape",
    duration: "全 20 集",
    releaseDate: "2025-12-05",
    tagline: "你认识的，究竟是哪一个我。",
    synopsis:
      "一名事业有成的律师突然被卷入一桩与自己过去有关的案件。随着调查深入，他白天体面严谨的精英形象，与夜晚那些无法解释的空白时间，逐渐显露出裂痕。剧集以强烈的心理悬疑感推进，用光影与构图暗示人格的分裂。演员在同一角色中切换两种截然不同的气质，表演极具张力。它不满足于制造反转，而是试图追问：当一个人无法面对自己做过的事，他会选择遗忘，还是继续伪装。主题深刻，节奏紧凑，很有港剧黄金年代的味道。",
  },
  {
    id: "26",
    title: "遗失的乐章",
    originalTitle: "The Lost Movement",
    category: "movie",
    genres: ["剧情", "音乐"],
    region: "法国",
    year: 2026,
    rating: 8.7,
    heat: 77,
    recommendWeight: 91,
    director: "伊莎贝尔·莫罗",
    cast: ["克洛伊·杜邦", "雨果·勒梅"],
    poster: "https://readdy.ai/api/search-image?query=cinematic%20music%20drama%20movie%20poster%2C%20pianist%20hands%20on%20an%20old%20piano%20lit%20by%20warm%20orange%20candlelight%2C%20intimate%20emotional%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=hh-m15&orientation=portrait",
    posterWide: "https://readdy.ai/api/search-image?query=cinematic%20grand%20piano%20on%20a%20stage%20in%20warm%20orange%20spotlight%20with%20dust%20in%20the%20air%2C%20emotional%20music%20drama%20mood%2C%20no%20text%2C%20wide%20composition&width=1200&height=675&seq=hh-m15w&orientation=landscape",
    duration: "108 分钟",
    releaseDate: "2026-06-12",
    tagline: "有些旋律，是用来怀念一个人的。",
    synopsis:
      "年轻钢琴家克洛伊在整理恩师遗物时，发现了一份从未公开的乐谱手稿——那是一首未完成的钢琴协奏曲，据说写给一位她从未听说过的人。为了还原这部作品，她踏上寻访当年知情者的旅程，也一点点走进老师沉默了一生的心事。影片将古典音乐与情感叙事完美融合，几场演奏戏的光影与运镜美得令人屏息。它讲述的是艺术如何承载记忆，也讲述了一段跨越时间的深情。落幕时那最后一个音符落下，全场仿佛都屏住了呼吸，余韵悠长。",
  },
];